import { type OrderDetails } from "@koala/sdk";
import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import { StyledLoyaltyContainer } from "../styles";
import { ConnectedStaticHeartIcon } from "../uielements";
import { FavoriteOrderCard } from "@/components/account/favorites/favoriteOrder";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import GenericErrorBoundary from "@/components/genericErrorBoundary";
import {
  StyledFavoritesFlexContainer,
  StyledNoDataContainer,
  StyledNoDataContent,
} from "@/components/uielements/favoriteCard/styles";
import { CSS_CLASSES } from "@/constants/cssClassNames";
import basketActions from "@/redux/basket/actions";
import meActions from "@/redux/me/actions";
import { type RootState } from "@/types/app";

class OrderHistory extends Component<ReduxProps> {
  componentDidMount() {
    this.props.fetchMePastOrders();
  }

  render() {
    const {
      reorderBasketId,
      mePastOrders,
      fetchMeOrderDetailsSuccess,
      reorderBasket,
    } = this.props;

    function handleReorder(orderDetails: OrderDetails) {
      fetchMeOrderDetailsSuccess(orderDetails);
      reorderBasket(orderDetails, "Order History", true);
    }

    if (!mePastOrders.length) {
      return (
        <StyledLoyaltyContainer>
          <StyledFavoritesFlexContainer
            className={CSS_CLASSES.LOYALTY.PAGE_HEADER}
          >
            <StringAccessor
              tag="h2"
              accessor="order_history.header"
              html={true}
            />
            <StyledNoDataContainer>
              <StyledNoDataContent>
                <ConnectedStaticHeartIcon />
                <StringAccessor
                  tag="h3"
                  accessor="order_history.orders_empty_state_header"
                  html={true}
                />
                <StringAccessor
                  tag="p"
                  accessor="order_history.orders_empty_state_subheader"
                  html={true}
                />
              </StyledNoDataContent>
            </StyledNoDataContainer>
          </StyledFavoritesFlexContainer>
        </StyledLoyaltyContainer>
      );
    }

    return (
      <StyledLoyaltyContainer>
        <StyledFavoritesFlexContainer
          className={CSS_CLASSES.LOYALTY.PAGE_HEADER}
        >
          <StringAccessor
            tag="h2"
            accessor="order_history.header"
            html={true}
          />
          {mePastOrders.map((order, index: number) => (
            <GenericErrorBoundary key={index}>
              <FavoriteOrderCard
                showReceiptLink
                order={order}
                index={index}
                reorderBasketId={reorderBasketId}
                reorderBasket={handleReorder}
                eventDetail="Order History"
              />
            </GenericErrorBoundary>
          ))}
        </StyledFavoritesFlexContainer>
      </StyledLoyaltyContainer>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  mePastOrders: state.app.me.pastOrders,
  reorderBasketId: state.app.basket.reorderBasketId,
});

const mapDispatchToProps = {
  fetchMePastOrders: meActions.fetchMePastOrders,
  fetchMeOrderDetailsSuccess: meActions.fetchMeOrderDetailsSuccess,
  reorderBasket: basketActions.reorderBasket,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(OrderHistory);
